<div class="iam-picker position-relative my-3">
    <div *ngIf="selectedUser && !editing" class="d-flex align-items-center border rounded p-2"
        (click)="startEditing()">
        <img src="assets/images/profile-default.png" alt="" class="avatar rounded-circle me-2" />
        <div class="text">
            <div class="name">{{ selectedUser.fullname }}</div>
            <div class="email text-muted">{{ selectedUser.email }}</div>
        </div>
    </div>

    <input *ngIf="editing || !selectedUser" #searchInput type="text" class="form-control" placeholder="Assign user"
        [(ngModel)]="searchText" (input)="onInput()" (blur)="stopEditing()" />

    @if(showDropdown) {
    <ul class="suggestions list-group position-absolute w-100 shadow-sm">
        @for (user of filteredUsers; track $index) {
        <li class="list-group-item list-group-item-action" (click)="selectUser(user)">
            <div class="d-flex align-items-center">
                <img src="assets/images/profile-default.png" alt="" class="avatar rounded-circle me-2" />
                <div class="text">
                    <div class="name">{{ user.fullname }}</div>
                    <div class="email text-muted">{{ user.email }}</div>
                </div>
            </div>
        </li>

        }
        @if (filteredUsers.length === 0) {
        <li *ngIf="" class="list-group-item text-center text-muted">
            No users found
        </li>
        }
    </ul>
    }

</div>